module.exports = {
  label: 'File History',
  Details: 'Tag Detail',
  view: 'View File',
  PlsInput: 'Pls Input',
  Query: 'Query',
  fileName: 'File Name',
  fileVersion: 'Version',
  jobType: 'File Type',
  fileType: 'File Format',
  fileSize: 'Size',
  createdBy: 'Created By',
  createdDate: 'Created Date',
  tagName: 'Tag Name',
  tagValue: 'Tag Value',
  DownloadFile: 'Do you want to save the file?',
  Succeed: 'Download Succeed.',
  Failed: 'Download Failed.',
  noFile: 'No files founded.',
  Refresh: 'Refresh',
  Upload: 'Upload',
  Delete: 'Delete',
  BatchDownload: 'Batch Download',
  SendEmail: 'Send Email',
  TransferAllToFileHistory: 'Transfer all to file history',
  ingotUpload: 'Ingot Upload',
  ingotLog: 'Ingot Log',
  synchronization: 'Synchronization',
  cancelSynchronization: 'Cancel Synchronization',
  synchronizationState: 'Synchronization State',
  operation: 'Operation',
  fileDownload: 'File Download',
  ExternalFileType: 'External fileType',
  LastSyncTime: 'LastSync time',
  DisplayTicketFile: 'Display ticket file',
  SendDestinationPortAgent: 'Send destination port agent',
  SentDestinationPortAgent: 'Sent destination port agent',
  ResetOneClickSend: 'Reset one click send',
  FileCreator: 'File Creator',
  FileCreationDate: 'File creation date',
  HasDeleted: 'Has it been deleted',
  SendSetOfProxyOrders: 'Send a set of proxy orders',
  ProxyName: 'Proxy Name',
  invoiceFlag: 'Invoice or not',
  invoiceFlag_Yes: 'Invoice',
  invoiceFlag_No: 'Non-invoice'
}
